import { CARD_TYPES, FRAME_WEIGHTS } from "../constants/editor";
import type { CardDraft, CardType } from "../shared/game";

export function findCardType(label: string): CardType {
  return CARD_TYPES.find((entry) => entry.label === label) ?? CARD_TYPES[0];
}

export function getFrameColor(card: CardDraft): string {
  return card.frameColorManual ?? findCardType(card.typeLabel).color;
}

export function getFrameWeightPx(card: CardDraft): number {
  return FRAME_WEIGHTS.find((weight) => weight.id === card.frameWeight)?.px ?? 3;
}
